import { createIcon } from './createIcon';

/**
 * Pencil-in-square "compose" glyph (ChatGPT-style new-chat affordance).
 * Lucide "square-pen" outline, with the box's corner radius bumped so it
 * reads soft at the 13px render size.
 */
export const ComposeIcon = createIcon({
  name: 'ComposeIcon',
  viewBox: '0 0 24 24',
  size: 13,
  children: (
    <>
      <path
        d="M12 3.5H6.5C4.84315 3.5 3.5 4.84315 3.5 6.5V17.5C3.5 19.1569 4.84315 20.5 6.5 20.5H17.5C19.1569 20.5 20.5 19.1569 20.5 17.5V12"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 2.625C19.2034 1.79657 20.5466 1.79657 21.375 2.625C22.2034 3.45343 22.2034 4.79657 21.375 5.625L12.362 14.638C12.1176 14.8823 11.8163 15.0609 11.487 15.157L8.61399 15.996C8.26326 16.0984 7.93835 15.7788 8.03599 15.427L8.84299 12.517C8.93857 12.1723 9.12086 11.858 9.37199 11.606L18.375 2.625Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export default ComposeIcon;
